import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Stock } from 'src/app/models/stock';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-edit-stock',
  template: ``,
  styleUrls: []
})
export class EditStockComponent {
  stock: Stock | null  = null;

  constructor(
    private invService: InventoryService,
    private activeRoute: ActivatedRoute
  ) {
    this.activeRoute.params.subscribe(params => {
    this.loadStock(params['id']);
    });
  }

  loadStock(id: number) {
    this.invService.getStockById(id).subscribe({
      next: (stock: Stock) => {
        this.stock = stock;
      },
      error: (err: any) => {}
    });
  }

}
